const generateSrcset = (image, widths = []) => {
	const imageUrl = new URL(image["src"]);
	return widths
		.filter((width) => width <= image["width"])
		.map((width) => {
			imageUrl.searchParams.set("width", width.toString());
			return `${imageUrl.href} ${width}w`;
		})
		.join(", ");
};

const createImageElement = (image, classes, sizes, productTitle) => {
	const previewImage = image["preview_image"];
	const newImage = new Image(previewImage["width"], previewImage["height"]);
	newImage.className = classes;
	newImage.alt = image["alt"] || productTitle;
	newImage.sizes = sizes;
	newImage.src = previewImage["src"];
	newImage.srcset = generateSrcset(
		previewImage,
		[165, 360, 533, 720, 940, 1066]
	);
	newImage.loading = "lazy";
	return newImage;
};

const checkSwatches = () => {
	document.querySelectorAll(".js-color-swatches-wrapper").forEach((wrapper) => {
		wrapper.querySelectorAll(".js-color-swatches input").forEach((input) => {
			input.addEventListener("click", (event) => {
				const primaryImage = wrapper.querySelector(".media--first");
				const secondaryImage = wrapper.querySelector(".media--second");
				const handleProduct = wrapper.dataset.product;

				if (event.currentTarget.checked && primaryImage) {
					wrapper
						.querySelector(".js-color-swatches-link")
						.setAttribute("href", event.currentTarget.dataset.variantLink);
					const currentColor = event.currentTarget.value;

					jQuery.getJSON(
						window.Shopify.routes.root + `products/${handleProduct}.js`,
						function (product) {
							const variant = product.variants.filter(
								(item) =>
									item.featured_media != null &&
									item.options.includes(currentColor)
							)[0];
							if (variant) {
								const newPrimaryImage = createImageElement(
									variant["featured_media"],
									primaryImage.className,
									primaryImage.sizes,
									product.title
								);

								if (newPrimaryImage.src !== primaryImage.src) {
									let flag = false;
									if (secondaryImage) {
										const secondaryImagePathname = new URL(secondaryImage.src).pathname;
										const newPrimaryImagePathname = new URL(newPrimaryImage.src).pathname;

										if (secondaryImagePathname == newPrimaryImagePathname) {
											primaryImage.remove();
											secondaryImage.classList.remove("media--second");
											secondaryImage.classList.add("media--first");
											flag = true;
										}
									}
									if (flag == false) {
										primaryImage.animate(
											{ opacity: [1, 0] },
											{ duration: 200, easing: "ease-in", fill: "forwards" }
										).finished;
										setTimeout(function () {
											primaryImage.replaceWith(newPrimaryImage);
											newPrimaryImage.animate(
												{ opacity: [0, 1] },
												{ duration: 200, easing: "ease-in" }
											);
											if (secondaryImage) {
												secondaryImage.remove();
											}
										}, 200);
									}
								}
							}
						}
					);
				}
			});
		});
	});
};

function colorSwatches() {
	checkSwatches();

	document.addEventListener("shopify:section:load", function () {
		checkSwatches();
	});
}

(function () {
	colorSwatches();
})();

/* ---- Color-group swatches ---- */
(function () {
	function swapCard(sw) {
		var group = sw.closest(".js-lpc");
		var wrapper = sw.closest(".card-wrapper");
		if (!group || !wrapper) return;
		var img = wrapper.querySelector(".media--first");
		if (img && sw.dataset.img) { img.removeAttribute("srcset"); img.src = sw.dataset.img; }
		var img2 = wrapper.querySelector(".media--second");
		if (img2) { img2.removeAttribute("srcset"); img2.src = (sw.dataset.img2 && sw.dataset.img2.length) ? sw.dataset.img2 : sw.dataset.img; }
		var titleLink = wrapper.querySelector(".card__title a");
		if (titleLink) { if (sw.dataset.title) titleLink.textContent = sw.dataset.title; if (sw.dataset.url) titleLink.setAttribute("href", sw.dataset.url); }
		var priceEl = wrapper.querySelector(".price .price-item--regular") || wrapper.querySelector(".price");
		if (priceEl && sw.dataset.price) priceEl.textContent = sw.dataset.price;
		var overlay = wrapper.querySelector(".js-color-swatches-link");
		if (overlay && sw.dataset.url) overlay.setAttribute("href", sw.dataset.url);
		group.querySelectorAll(".color-swatch").forEach(function (s) { s.classList.remove("is-active"); });
		sw.classList.add("is-active");
	}

	function activatePdp(sw) {
		if (sw.classList.contains("is-active") || !sw.dataset.url) return;
		var modal = sw.closest("quick-add-modal");
		if (modal && typeof modal.show === "function") {
			var fake = document.createElement("a");
			fake.setAttribute("data-product-url", sw.dataset.url);
			modal.show(fake);
		} else {
			window.location.href = sw.dataset.url;
		}
	}

	document.addEventListener("click", function (e) {
		var gridSw = e.target.closest(".js-lpc .color-swatch");
		if (gridSw) { e.preventDefault(); swapCard(gridSw); return; }
		var pdpSw = e.target.closest(".js-lpc-pdp .color-swatch");
		if (pdpSw) { e.preventDefault(); activatePdp(pdpSw); }
	});

	document.addEventListener("keydown", function (e) {
		if (e.key !== "Enter" && e.key !== " ") return;
		var gridSw = e.target.closest(".js-lpc .color-swatch");
		if (gridSw) { e.preventDefault(); swapCard(gridSw); return; }
		var pdpSw = e.target.closest(".js-lpc-pdp .color-swatch");
		if (pdpSw && e.key === "Enter") { e.preventDefault(); activatePdp(pdpSw); }
	});

	// Capture phase: before the quick-view opens, point its button at the card's ACTIVE color
	document.addEventListener("click", function (e) {
		var qaBtn = e.target.closest("[data-product-url]");
		if (!qaBtn) return;
		var wrapper = qaBtn.closest(".card-wrapper");
		if (!wrapper) return;
		var activeSw = wrapper.querySelector(".js-lpc .color-swatch.is-active");
		if (activeSw && activeSw.dataset.url) qaBtn.setAttribute("data-product-url", activeSw.dataset.url);
	}, true);
})();